import { forwardRef, type SVGProps } from 'react';

const MicPaths = () => (
  <>
    <rect height="11" rx="3" stroke="currentColor" strokeWidth={1.7} width="6" x="9" y="3" />
    <path d="M5.5 11a6.5 6.5 0 0 0 13 0M12 17.5V21" stroke="currentColor" strokeLinecap="round" strokeWidth={1.7} />
  </>
);

const SLASH_PATH = 'M3.5 3.5l17 17';

export const MicIcon = forwardRef<SVGSVGElement, SVGProps<SVGSVGElement>>((props, ref) => (
  <svg fill="none" height="1em" ref={ref} viewBox="0 0 24 24" width="1em" xmlns="http://www.w3.org/2000/svg" {...props}>
    <MicPaths />
  </svg>
));

MicIcon.displayName = 'MicIcon';

export const MicOffIcon = forwardRef<SVGSVGElement, SVGProps<SVGSVGElement>>((props, ref) => (
  <svg fill="none" height="1em" ref={ref} viewBox="0 0 24 24" width="1em" xmlns="http://www.w3.org/2000/svg" {...props}>
    <MicPaths />
    <path d={SLASH_PATH} stroke="currentColor" strokeLinecap="round" strokeWidth={1.7} />
  </svg>
));

MicOffIcon.displayName = 'MicOffIcon';

export const PlayIcon = forwardRef<SVGSVGElement, SVGProps<SVGSVGElement>>((props, ref) => (
  <svg fill="none" height="1em" ref={ref} viewBox="0 0 24 24" width="1em" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path d="M5 3L19 12L5 21V3Z" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} />
  </svg>
));

PlayIcon.displayName = 'PlayIcon';

const VideoPaths = () => (
  <>
    <rect height="11" rx="2.5" stroke="currentColor" strokeWidth={1.7} width="12" x="2.5" y="6.5" />
    <path d="M14.5 10.5l6-3.2v9.4l-6-3.2z" stroke="currentColor" strokeLinejoin="round" strokeWidth={1.7} />
  </>
);

export const VideoIcon = forwardRef<SVGSVGElement, SVGProps<SVGSVGElement>>((props, ref) => (
  <svg fill="none" height="1em" ref={ref} viewBox="0 0 24 24" width="1em" xmlns="http://www.w3.org/2000/svg" {...props}>
    <VideoPaths />
  </svg>
));

VideoIcon.displayName = 'VideoIcon';

export const VideoOffIcon = forwardRef<SVGSVGElement, SVGProps<SVGSVGElement>>((props, ref) => (
  <svg fill="none" height="1em" ref={ref} viewBox="0 0 24 24" width="1em" xmlns="http://www.w3.org/2000/svg" {...props}>
    <VideoPaths />
    <path d={SLASH_PATH} stroke="currentColor" strokeLinecap="round" strokeWidth={1.7} />
  </svg>
));

VideoOffIcon.displayName = 'VideoOffIcon';

export const CameraPlaceholderIcon = forwardRef<SVGSVGElement, SVGProps<SVGSVGElement>>((props, ref) => (
  <svg fill="none" height="1em" ref={ref} viewBox="0 0 24 24" width="1em" xmlns="http://www.w3.org/2000/svg" {...props}>
    <circle cx="12" cy="8.5" fill="currentColor" r="4" />
    <path d="M4 20c0-4 3.6-6.5 8-6.5s8 2.5 8 6.5" fill="currentColor" />
  </svg>
));

CameraPlaceholderIcon.displayName = 'CameraPlaceholderIcon';
